/* eslint-disable no-restricted-syntax, no-await-in-loop, no-continue, no-promise-executor-return, consistent-return, no-void, max-len, class-methods-use-this, no-underscore-dangle, no-undef, no-plusplus, prefer-destructuring, no-param-reassign, no-use-before-define, no-nested-ternary */
// Ported from newdtrader (packages/core/src/_common/base/dfunded); kept in its
// original style so fixes can be carried across the two copies.
/**
 * A funded rejection must look like a Deriv rejection. Deriv's own code and
 * wording pass through untouched (they come from the master account's real
 * buy/sell); DFunded's risk rules are codes only, so they get a sentence.
 */
const DFUNDED_MESSAGES = {
    SESSION_INVALID            : 'Your DFunded session expired. Please log in again.',
    SESSION_EXPIRED            : 'Your DFunded session expired. Please log in again.',
    ACCOUNT_NOT_ACTIVE         : 'This account is closed (passed or breached), so no more trades can be placed on it.',
    ACCOUNT_NOT_FOUND          : 'This session cannot trade that account.',
    MAX_STAKE_EXCEEDED         : 'The stake is above the maximum stake allowed per trade on this account.',
    INSUFFICIENT_EQUITY        : 'The stake is more than the balance available on this account.',
    MAX_OPEN_TRADES            : 'This account already has the maximum number of open trades.',
    DAILY_LOSS_LIMIT           : 'The daily loss limit has been reached. Trading resumes on the next trading day (UTC).',
    PAYOUT_PENDING             : 'Trading is paused while your payout is being processed. It resumes as soon as the payout is paid or declined.',
    DERIV_UNAVAILABLE          : 'Deriv is not reachable right now. Nothing was bought; please try again in a moment.',
    TOTAL_DRAWDOWN_LIMIT       : 'The maximum total loss has been reached. This account can no longer trade.',
    STAKE_EXCEEDS_LOSS_HEADROOM: 'This stake could take the account past its loss limit. Use a smaller stake.',
    MASTER_RISK_LIMIT          : 'Trading is temporarily paused by DFunded risk controls. Try again shortly.',
    PROGRAM_DISABLED           : 'This account type is not open for trading right now.',
    ELIGIBILITY_NOT_VERIFIED   : 'This account is not cleared for trading yet. Contact support.',
    RATE_LIMITED               : 'Too many orders at once. Slow down and try again.',
    ACCOUNT_MISMATCH:
        'This tab was trading a different funded account from the one now signed in. Reload the page to continue on the current account.',
    INTERNAL_ERROR: 'DFunded could not process the request. Please try again.',
};

class DFundedError extends Error {
    constructor(code, message) {
        super(message || DFUNDED_MESSAGES[code] || String(code).split('_').join(' ').toLowerCase());
        this.name = 'DFundedError';
        this.code = code;
        // Wording the server sent with the code (a refusal's figures) is kept
        // under its own name so toDerivError prefers it to the generic sentence.
        this.serverMessage = message || undefined;
    }
}

/** `{ code, message }` for the `error` field of a Deriv-style response. */
const toDerivError = error => {
    const code = String((error && error.code) || 'DFundedError');
    const raw = error instanceof Error ? error.message : String((error && error.message) || error);
    return { code, message: (error && error.serverMessage) || DFUNDED_MESSAGES[code] || raw };
};

module.exports = { DFUNDED_MESSAGES, DFundedError, toDerivError };
